export const titles = {
    flterBy: 'Filter By',
    salesOrder: 'Sales Order',
    creditNote:'Credit Note'
}

export const fields = {
    customer: {
        title: 'Customer',
        placeholder: 'Select Customer'
    },
    branch: {
        title: 'Branch',
        placeholder: 'Select Branch'
    }
}

export const buttons = {
    applyFilter: 'Apply Filter',
    reset: 'Reset'
}

export const headers = {
    creditNoteNumber: 'Credit Note No.',
    creditNoteDate: 'Credit Note Date',
    creditAmount: 'Credit Amount (Rs)',
    branchName: 'Branch',
    refNo: 'Reference No.',
    integrated_ref_no : 'Integrated Reference Number',
    irn_code : 'IRN Code',
    approved_on : "Approved On",
    customerName: 'Customer Name',
    remarks: 'Remarks',
    createdOn: 'Created On',
    createdBy: 'Created By',
    modifiedOn: 'Modified On',
    modifiedBy: 'Modified By',
    edit: 'Delete'
}